import React from "react";
import classnames from "classnames";
import { CheckCircleFilled, ClockCircleFilled, MinusCircleFilled, WarningFilled } from "@payping/icons";

import { StatusIconEnum } from "./types";
import wizardStyle from "../../../assets/scss/Wizard.module.scss";

interface Props {
  status: StatusIconEnum;
}

const iconWidth = "5rem";

const StatusIcon: React.FC<Props> = ({ status }) => {
  switch (status) {
    case StatusIconEnum.success:
      return <CheckCircleFilled className="align-middle color--success" width={iconWidth} />;
    case StatusIconEnum.error:
      return <WarningFilled className="align-middle color--danger" width={iconWidth} />;
    case StatusIconEnum.pending:
      return <ClockCircleFilled className="align-middle color--cta" width={iconWidth} />;
    case StatusIconEnum.userPending:
      return (
        <ClockCircleFilled className={classnames("align-middle color--cta", wizardStyle.infoPulse)} width={iconWidth} />
      );
    default:
      return <MinusCircleFilled className="align-middle color--gray300" width={iconWidth} />;
  }
};

export default StatusIcon;
